<template>
  <div class="bg-white tabs-palliative">
    <div class="mx-auto stickys">
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        class="tabs-bottom-none bdr-bottom-none"
      >
        <el-tab-pane label="Epilepsy and Stroke" name="first"> </el-tab-pane>
        <!-- <el-tab-pane
          label="Neurodegenerative Disorders"
          name="second"
        ></el-tab-pane> -->
        <el-tab-pane label="Alzheimer's Disease" name="third"></el-tab-pane>
        <el-tab-pane label="ALS" name="forth"></el-tab-pane>
        <el-tab-pane label="Parkinson's Disease" name="fifth"> </el-tab-pane>
        <el-tab-pane label="Multiple Sclerosis" name="sixth"> </el-tab-pane>
        <el-tab-pane label="Huntington's Disease" name="seventh"></el-tab-pane>
        <el-tab-pane label="Migraine" name="eight"></el-tab-pane>
      </el-tabs>
    </div>

    <div class="lg:px-12 md:px-12 px-5 lg:pb-16 md:pb-12 pb-8">
      <div class="container relative lg:flex md:flex start-items">
        <div v-if="activeName === 'first'">
          <Eplipsey />
        </div>
        <div v-else-if="activeName === 'second'">
          <NeurodegenerativeDisorders />
        </div>
        <div v-else-if="activeName === 'third'">
          <Alzheimer />
        </div>
        <div v-else-if="activeName === 'forth'">
          <ALS />
        </div>
        <div v-else-if="activeName === 'fifth'">
          <Parkinson />
        </div>
        <div v-else-if="activeName === 'sixth'">
          <Sclerosis />
        </div>
        <div v-else-if="activeName === 'seventh'">
          <Huntington />
        </div>
        <div v-else-if="activeName === 'eight'">
          <Migraine />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Eplipsey from "./components/Eplipsey.vue";
import NeurodegenerativeDisorders from "./components/Neurodegenerative-disorders.vue";
import Alzheimer from "./components/Alzheimer.vue";
import ALS from "./components/ALS.vue";
import Parkinson from "./components/Parkinson.vue";
import Sclerosis from "./components/Sclerosis.vue";
import Huntington from "./components/Huntington.vue";
import Migraine from "./components/Migraine.vue";
export default {
  components: {
    Eplipsey,
    Alzheimer,
    ALS,
    Parkinson,
    Sclerosis,
    Huntington,
    Migraine,
    NeurodegenerativeDisorders,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  mounted() {
    const tab = this.$route.query.tab;
    if (tab) {
      this.activeName = tab;
    }
  },
  watch: {
    $route(to) {
      const tab = to.query.tab;
      if (tab) {
        this.activeName = tab;
      }
    },
  },
};
</script>
<style scoped>
/* Scoped styles using ::v-deep for deep selector */
::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
  height: 0px !important;
}

::v-deep .el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0pxn !important;
  background-color: transparent !important;
  z-index: 1;
  -webkit-transition: -webkit-transform 0.3s
    cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  list-style: none;
}
.stickys {
  position: sticky;
  top: 84px; /* Adjust for navbar height */
  z-index: 9; /* Ensure visibility */
  background-color: white;
  padding: 50px 0px 10px 0px; /* Ensure visibility */
}
::v-deep .el-tabs__header .el-tab {
  background-color: #f0f0f0;
  color: #333;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

::v-deep .el-tabs__item.is-active {
  color: #ffffff !important;
  background-color: #4f0a4b !important;
  border: 1px solid #4f0a4b !important;
}

::v-deep .el-tabs__item {
  padding: 0px 26px !important;
  margin-right: 15px !important;
  height: 38px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 38px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
  position: relative;
  border-radius: 6px !important;
}

::v-deep .el-tabs__header .el-tab i {
  margin-right: 8px; /* Add some space between icon and text */
}

.sticky-sidebar {
  position: sticky;
  top: 130px;
  z-index: 8;
  /* max-height: calc(100vh - 130px); */
  max-height: fit-content;
  /* overflow-y: auto; */
  background-color: white; /* Ensure visibility */
}

.start-items {
  align-items: flex-start !important;
}
</style>
